// ImageEditor.tsx
import React from 'react';
import cx from 'classnames';

import './ImageEditor.styles.scss';

export interface ImageEditorProps {
  value: string;
  onChange: (value: string) => void;
  onUpload: () => void;
  autoFocus?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onSubmit?: (value: string) => void;
  onBlur?: (value: string) => void;
  disabled?: boolean;
}

export const ImageEditor: React.FC<ImageEditorProps> = ({
  value,
  onChange,
  onUpload,
  autoFocus = false,
  className = "",
  style = {},
  onSubmit,
  onBlur,
  disabled = false,
}) => {
  return (
    <div 
      className={cx("ImageEditor", className, { 'ImageEditor--disabled': disabled })}
      style={style}
      onMouseDown={(e) => {
        // prevent cell selection on click
        e.stopPropagation();
      }}
    >
      {/* Left: image icon */}
      <img
        src="gif/image2.gif"
        alt="Image"
        className="ImageEditor__icon"
        onMouseDown={(e) => e.preventDefault()}
      />
      
      {/* Value input area */}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            onSubmit?.(value);
          }
          // prevent spreadsheet global handlers from stealing focus/keys
          e.stopPropagation();
        }}
        onBlur={(e) => {
          if (onBlur) {
            onBlur(e.target.value);
          }
        }}
        className="ImageEditor__input"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        autoFocus={autoFocus}
        disabled={disabled}
        readOnly={disabled}
      />

      {/* Right: upload icon button */}
      <button
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!disabled) {
            onUpload();
          }
        }}
        title="Upload Image"
        className="ImageEditor__upload-button"
        disabled={disabled}
      >
        <img src="gif/upload.gif" alt="Upload" className="ImageEditor__upload-icon" />
      </button>
    </div>
  );
};

